import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { saveAddressDetails } from './AddressDetailsPage.duck';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  Footer,
  LayoutSideNavigation,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  Page,
  UserNav,
} from '../../components';
import { AddressDetailsForm } from '../../forms';
import { TopbarContainer } from '../../containers';
import config from '../../config';

import { isScrollingDisabled } from '../../ducks/UI.duck';
import css from './AddressDetailsPage.css';
import { getConnectCalendarTabStatus } from '../../ducks/TabPanels.duck';
import { createRawPropertiesForGTM } from '../../util/gtm/gtmCreateProperties';
import { createConversionEvents } from '../../util/conversions/conversionsHelpers';
import { EVENT_CONVERSION_CREATE_ACCOUNT_DRIVER_CREDENTIALS } from '../../util/conversions/conversionsConstants';
import { pushGTMGuestVerify } from '../../util/gtm/gtmHelpers';
import { EVENT_SAVED_ADDRESS_DETAILS } from '../../util/gtm/gtmConstants';

const { LatLng } = sdkTypes;

export const AddressDetailsPageComponent = props => {
  const {
    currentUser,
    scrollingDisabled,
    intl,
    onSubmitAddressDetailsForm,
    saveAddressDetailsSuccess,
    saveAddressDetailsError,
    saveAddressDetailsInProgress,

    connectCalendarTabVisibility,
    fetchCalendarVisibility,
  } = props;

  useEffect(() => {
    fetchCalendarVisibility();
  }, []);

  let tabs = [...config.custom.tabs];
  tabs = tabs
    .map(tab => ({ ...tab }))
    .filter(tab => {
      if (tab.linkProps.name === 'SyncCalenderPage') {
        return Boolean(connectCalendarTabVisibility);
      }
      return true;
    });
  const currentTab = tabs.find(tab => tab.linkProps.name === 'AddressDetailsPage');
  if (currentTab) {
    currentTab.selected = true;
  }

  const ensuredCurrentUser = ensureCurrentUser(currentUser);
  const protectedData = ensuredCurrentUser.attributes.profile.protectedData || {};
  const {
    blockNo,
    location,
    building,
    floorUnit,
    city,
    country,
    postalCode,
    neighborhood,
  } = protectedData;
  const { selectedPlace } = location || {};
  const { address, origin } = selectedPlace || {};
  const initialValues = {
    blockNo,
    location: {
      search: address,
      selectedPlace: {
        address,
        origin: new LatLng(origin && origin.lat, origin && origin.lng),
      },
    },
    neighborhood,
    building,
    floorUnit,
    city,
    country,
    postalCode,
  };

  const addressInfoForm = ensuredCurrentUser.id ? (
    <AddressDetailsForm
      className={css.form}
      initialValues={initialValues}
      currentUser={currentUser}
      inProgress={saveAddressDetailsInProgress}
      ready={saveAddressDetailsSuccess}
      saveAddressDetailsError={saveAddressDetailsError}
      onSubmit={values => {
        const {
          blockNo,
          location,
          building,
          floorUnit,
          city,
          country,
          postalCode,
          neighborhood,
        } = values;
        const {
          selectedPlace: { address, origin },
        } = location;
        const updatedValues = {
          blockNo,
          location: {
            search: address,
            selectedPlace: {
              address,
              origin: new LatLng(origin.lat, origin.lng),
            },
            neighborhood,
            building,
            floorUnit,
          },
          neighborhood,
          building,
          floorUnit,
          city,
          country,
          postalCode,
        };
        onSubmitAddressDetailsForm(updatedValues);
        const properties = createRawPropertiesForGTM({
          props,
        });
        // pushGTMGuestVerify({
        //   props: this.props,
        //   event: EVENT_SAVED_ADDRESS_DETAILS,
        // });
        // createConversionEvents(
        //   properties,
        //   EVENT_CONVERSION_CREATE_ACCOUNT_DRIVER_CREDENTIALS,
        //   'click'
        // );
      }}
    />
  ) : null;

  const title = intl.formatMessage({ id: 'AddressDetailsPage.title' });

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer
            currentPage="AddressDetailsPage"
            desktopClassName={css.desktopTopbar}
            mobileClassName={css.mobileTopbar}
          />
          <UserNav selectedPageName="AddressDetailsPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} user={ensuredCurrentUser} />
        <LayoutWrapperMain>
          <div className={css.content}>
            <h1 className={css.title}>
              {/* <FormattedMessage id="AddressDetailsPage.heading" /> */}
            </h1>
            {addressInfoForm}
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

AddressDetailsPageComponent.defaultProps = {
  currentUser: null,
  saveAddressDetailsSuccess: false,
  saveAddressDetailsError: false,
};

const { bool } = PropTypes;

AddressDetailsPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
  scrollingDisabled: bool.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  // Topbar needs user info.
  const { currentUser } = state.user;
  const {
    saveAddressDetailsSuccess,
    saveAddressDetailsError,
    saveAddressDetailsInProgress,
  } = state.AddressDetailsPage;
  const { connectCalendarTabVisibility } = state.tabPanels;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
    saveAddressDetailsSuccess,
    saveAddressDetailsError,
    saveAddressDetailsInProgress,
    connectCalendarTabVisibility,
  };
};

const mapDispatchToProps = dispatch => ({
  onSubmitAddressDetailsForm: values => dispatch(saveAddressDetails(values)),
  fetchCalendarVisibility: () => dispatch(getConnectCalendarTabStatus()),
});

const AddressDetailsPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(AddressDetailsPageComponent);

AddressDetailsPage.loadData = () => {
  // Since verify email happens in separate tab, current user's data might be updated
  return fetchCurrentUser();
};

export default AddressDetailsPage;
